import { render, staticRenderFns } from "./TrailersCsvImportModal.vue?vue&type=template&id=4dd9dd6d&scoped=true&"
import script from "./TrailersCsvImportModal.vue?vue&type=script&lang=js&"
export * from "./TrailersCsvImportModal.vue?vue&type=script&lang=js&"
import style0 from "./TrailersCsvImportModal.vue?vue&type=style&index=0&id=4dd9dd6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd9dd6d",
  null
  
)

export default component.exports